import { render, staticRenderFns } from "./ImprestAttachmentPreview.vue?vue&type=template&id=7efcbf64&scoped=true"
import script from "./ImprestAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./ImprestAttachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./ImprestAttachmentPreview.vue?vue&type=style&index=0&id=7efcbf64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcbf64",
  null
  
)

export default component.exports